import { Component, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgRedux, Select } from '@angular-redux3/store';
import { Observable, Subscription } from 'rxjs';
import { BusinessStatus } from '../../../../store/entities';
import { ASetMessage, ASync, PlaylistRemoteAppState } from '../../../../store';

@Component({
  selector: 'mwo-sync-confirm',
  templateUrl: './sync-confirm.component.html',
  styleUrls: ['./sync-confirm.component.scss']
})
export class SyncConfirmComponent implements OnDestroy {

  @Select(['player', 'businessStatus']) businessStatus$: Observable<BusinessStatus>;
  private subscription$: Subscription;

    constructor(private dialog: MatDialog,
                private dialogRef: MatDialogRef<SyncConfirmComponent>,
                private ngRedux: NgRedux<PlaylistRemoteAppState>) { }

    onSyncConfirmation() {
      if ( this.subscription$ ) {
        return;
      }
      this.subscription$ = this.businessStatus$.subscribe((status) => {
        if (status?.syncStatus?.type !== 'FINISHED' || status?.downloadStatus?.type !== 'FINISHED') {
          if (status?.syncStatus?.type === 'OFFLINE') {
            this.ngRedux.dispatch(ASetMessage('Cannot sync when offline'));
          } else {
            this.ngRedux.dispatch(ASetMessage('Sync already in progress'));
          }
        } else {
          this.ngRedux.dispatch(ASetMessage('Sync request sent'));
          this.ngRedux.dispatch(ASync());
        }
        this.closeDialog();
      });
    }

    closeDialog() {
      this.dialogRef.close();
    }

    ngOnDestroy(): void {
      if (this.subscription$) {
        this.subscription$.unsubscribe();
        this.subscription$ = null;
      }
    }
}
